import { Controller } from "@hotwired/stimulus"
import flatpickr from "flatpickr"
import * as bootstrap from "bootstrap"

// Optional: Import styles if needed and not globally included
// import 'flatpickr/dist/flatpickr.min.css'

// Connects to data-controller="date-range"
export default class extends Controller {
  static targets = [ "modal", "startDate", "endDate" ]

  setScreenWidth() {
    const width = window.innerWidth
    // Store in cookie or hidden field
    document.cookie = `screen_width=${width}; path=/`
  }


  connect() {
    // console.log("Date range controller connected");
    this.setScreenWidth()
    window.addEventListener("resize", this.setScreenWidth.bind(this))
    // Initialize flatpickr on the inputs when controller connects
    flatpickr(this.startDateTarget, {
      altInput: true, // Show readable format to user
      altFormat: "M j, Y",
      dateFormat: "Y-m-d", // Format sent to server
      defaultDate: this.startDateTarget.value || "today" // Use value from ERB or default
    });
    flatpickr(this.endDateTarget, {
      altInput: true,
      altFormat: "M j, Y",
      dateFormat: "Y-m-d",
      defaultDate: this.endDateTarget.value || "today"
    });

    // Get Bootstrap Modal instance
    this.modalInstance = new bootstrap.Modal(this.modalTarget);
  }

  disconnect() {
    window.removeEventListener("resize", this.setScreenWidth.bind(this))
    // Cleanup flatpickr instances if needed, though usually okay
  }

  openModal(event) {
    // console.log('the beginning of the modal')
    event.preventDefault();
    this.modalInstance.show();
  }

  submitCustomDate(event) {
    // Prevent default form submission if needed, Turbo handles it automatically
    // event.preventDefault(); // Usually not needed with Turbo GET forms

    // Hide modal after submission is triggered
    // console.log('somewhere in the modal')
    this.modalInstance.hide();

    // Turbo should automatically submit the form via GET request now
    // The controller action will respond with Turbo Streams
    // Optionally, you could manually make a Turbo request here if needed,
    // but letting the form submit is simpler.
  }
}